import './TControlButton.scss'
export let TControlButton = ({ title, type, className,}) => {
  return (
    <div className={`TControlButton ${className}`}>
      <button type={type} className="button-three">{title}</button>
    </div>
  )
}